import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const ellipsisVertical: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3-2.25v1.5q0 .316-.219.531A.72.72 0 0 1 2.25 0H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-.75v-1.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-3h1.5q.31 0 .531.219A.74.74 0 0 1 3-2.25m0-4v1.5q0 .316-.219.531A.72.72 0 0 1 2.25-4H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-4.75v-1.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-7h1.5q.31 0 .531.219A.74.74 0 0 1 3-6.25m0-4v1.5q0 .316-.219.531A.72.72 0 0 1 2.25-8H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-8.75v-1.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-11h1.5q.31 0 .531.219A.74.74 0 0 1 3-10.25m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "3",
  }
};